import React,{ Component } from "react";
import { connect } from "react-redux";
import { getConnectionProxies, deleteConnectionProxy,setConnectionProxyPageInfo } from "../../actions/actionConnectionProxies";
import { Link } from "react-router-dom";
import { Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter, Card, CardBody, CardHeader } from "reactstrap";
import { NotificationManager } from "react-notifications";
import LoadingSpinner from "../../components/LoadingSpinner/index";
import "react-table/react-table.css";
import Proptypes from "prop-types";
import BreadCrumbCompo from "../../components/Breadcrumb/BreadCrumbCompo";
import DataTable from "../../components/Table/Table";
import {getLicenses} from "../../actions/actionSystemInfo";

const routes = [
    {name: "Home",path:"/userdashboard",isActive: false},
    {name: "ConnectionProxies",path:"/connectionProxies",isActive: true}
];

class ConnectionProxies extends Component{
    constructor(props){
        super(props);

        this.state = {
            modal: false,
            pages: 1,
            connection_proxyId: null,
        };

        this.deleteConfirm = this.deleteConfirm.bind(this);
        this.deleteConnectionProxyAction = this.deleteConnectionProxyAction.bind(this);
        this.handleDeleteSuccess = this.handleDeleteSuccess.bind(this);
        this.handleDeleteError = this.handleDeleteError.bind(this);
        this.cancelDelete = this.cancelDelete.bind(this);
    }

    componentDidMount() {
        this.props.getConnectionProxies();
    }

    deleteConfirm(connection_proxyId){
        this.setState({modal: !this.state.modal,
            connection_proxyId: connection_proxyId});
    }

    cancelDelete(){
        this.setState({modal: !this.state.modal}); 
    }

    deleteConnectionProxyAction(){
        this.props.deleteConnectionProxy(this.state.connection_proxyId).
            then(() => this.handleDeleteSuccess()).
            catch(() => this.handleDeleteError());
    }	

    handleDeleteSuccess(){
        const {deleteConnectionProxyErrorMessage} = this.props;
        if(deleteConnectionProxyErrorMessage) {
            NotificationManager.error(deleteConnectionProxyErrorMessage,"Delete ConnectionProxy Failed", 3000);
        }else{
            NotificationManager.success("Successfully Deleted ConnectionProxy","Delete ConnectionProxy", 3000);
            this.setState({modal: false});
            this.props.getConnectionProxies();
        }
    }

    handleDeleteError(){
        const {deleteConnectionProxyError} = this.props;
        if(deleteConnectionProxyError){
            NotificationManager.error(deleteConnectionProxyError,"Failed to Delete ConnectionProxy", 3000);
            this.props.history.push("/connection_proxies");
        }else{
            NotificationManager.error("Failed to Delete ConnectionProxy","Delete ConnectionProxy", 3000);
            this.props.history.push("/connection_proxies");
        }
    }

    render(){
        if (this.props.getConnectionProxiesLoading){
            return (<div> <LoadingSpinner /></div>);
        }

        const { connection_proxies } = this.props;

        const columns = [
            {
                type: "text",
                name: "Server Address",
                accessor: "server_address",
                filterable: true,
                sortable: true
            },
            {
                type: "text",
                name: "Zone Name",
                accessor: "zone_name",
                filterable: false,
                sortable: true
            },
            {
                type: "text",
                name: "Connection Type",
                accessor: "connection_proxy_type",
                filterable: true,
                sortable: true
            },
        ];

        const actions = [
            { id: "view", icon: "fa-eye", description: "View" },
            { id: "edit", icon: "fa-pencil", description: "Edit" },
            { id: "delete", icon: "fa-trash", description: "Delete" },
        ];

        const onAction = (action, item) => {
            switch (action) {
                case "view":
                    this.props.history.push(`/view_connection_proxy/${item.connection_proxy_id}`);
                break;

                case "edit":
                    this.props.history.push(`/update_connection_proxy/${item.connection_proxy_id}`);
                break;

                case "delete":
                    this.deleteConfirm(item.connection_proxy_id);
                break;
            }
        }
        
        return (
            <div className="profile-page">
                <BreadCrumbCompo routes={routes}/>
                <Row>
                    <Col sm={{ size: 10, order: 3, offset: 1 }}>
                        <Card >
                            <CardHeader>
                            <div className="title-head">
                                <i className="fa fa-plug"></i> <strong>Connection Proxies</strong>
                                </div>
                                <Link className="pull-right add-btn" to={{ pathname: "/create_connection_proxy" }}>
                                    <button className="pull-right adduser-btn" size="sm" color="dark">
                                    <i className="fa fa-plus" aria-hidden="true"></i>
                                   Add
                                    </button>
                                </Link> 
                               
                            </CardHeader>
                            <CardBody className="p-0">
                                <DataTable
                                    id="connection_proxies"
                                    data={connection_proxies}
                                    columns={columns}
                                    actions={actions}
                                    onAction={onAction}
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                <Modal isOpen={this.state.modal} toggle={this.cancelDelete} centered={true} className="user-modal">
                    <ModalHeader toggle={this.cancelDelete}>Are you sure you want to delete this ConnectionProxy?
                    </ModalHeader>
                    <ModalFooter>
                        <Button onClick={this.cancelDelete} size="sm" 
                        className="cancel-button"
                        color=" basic"> Close</Button>
                        <Button onClick={this.deleteConnectionProxyAction} size="sm" 
                        className="delete-button"
                        color="danger"> Delete</Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

ConnectionProxies.propTypes = {
    getConnectionProxies: Proptypes.func.isRequired,
    deleteConnectionProxy: Proptypes.func.isRequired,
    deleteConnectionProxyErrorMessage: Proptypes.func,
    deleteConnectionProxyError: Proptypes.func,
    history: Proptypes.object.isRequired,
    connection_proxies: Proptypes.array,
    createConnectionProxyLoading: Proptypes.bool,
    className: Proptypes.func
};


export default connect(state => ({
    connection_proxies: state.connection_proxies.connection_proxies || [],
    createConnectionProxyLoading: state.connection_proxies.createConnectionProxyLoading || false,
    deleteConnectionProxyErrorMessage: state.connection_proxies.deleteConnectionProxyErrorMessage || null,
    deleteConnectionProxyLoading: state.connection_proxies.deleteConnectionProxyLoading || false,
    deleteConnectionProxyError: state.connection_proxies.deleteConnectionProxyError || null,
    getConnectionProxiesLoading: state.connection_proxies.getConnectionProxiesLoading || null,
    pages : {pageSize : state.connection_proxies.pageSize, pageNo : state.connection_proxies.pageNo},
}), 
dispatch => ({
    getConnectionProxies: () => dispatch(getConnectionProxies()),
    getLicenses: () => dispatch(getLicenses()),
    deleteConnectionProxy: (data) => dispatch(deleteConnectionProxy(data)),
    setPageInfo : (data)=> dispatch(setConnectionProxyPageInfo(data)),
}))(ConnectionProxies);